var map = {
	"./aceitera.jpg": 972,
	"./antecedentes.jpg": 244,
	"./arbol_morera.jpg": 887,
	"./bala_canon.jpg": 492,
	"./capilla.jpg": 872,
	"./colonia.jpg": 427,
	"./epoca_moderna.jpg": 108,
	"./german_gedovius.jpg": 775,
	"./molino_aceite.jpg": 104,
	"./piedra_molino.jpg": 312,
	"./piedras_destilar.jpg": 77,
	"./revolucion.jpg": 364,
	"./rio_morales.jpg": 956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;